export const noteOutputEnumEnum = {
  NOTE: 'NOTE',
  SUMMARY: 'SUMMARY',
  EXPANDED: 'EXPANDED',
} as const

export type NoteOutputEnumEnum = (typeof noteOutputEnumEnum)[keyof typeof noteOutputEnumEnum]

export type NoteOutputEnum = NoteOutputEnumEnum